@if (labelKey) {
  <label for="custom_input_{{ id }}" [class.reduced-height]="reducedHeight" [fiTranslation]="labelKey" [replaceKeys]="replaceKeys"></label>
}
<ng-template #shared>
  @if (type === 'SELECT' || type === 'MULTI_SELECT' || type === 'SUGGEST') {
    <div
      [class.upper]="upperDropdown"
      [class.open]="openDropdown" class="dropdown"
      [id]="listboxId"
      role="listbox"
      [attr.aria-multiselectable]="type === 'MULTI_SELECT' ? 'true' : null"
      [style.height]="openDropdown ? calculatedMenuHeight : ''">
      @if (allOptionsKey && selectedOptionsKey || showSelectedOnTop) {
        @if (oldSelectedValues.size && selectedOptionsKey) {
          <div class="section-text" [hasHTMLTags]="sectionIsHtml" [fiTranslation]="selectedOptionsKey" [replaceKeys]="replaceKeys"></div>
        }
        @for (opt of displayedOptions; track opt) {
          @if (oldSelectedValues.has(opt.value)) {
            <button type="button" [style]="opt.style" [class.has-image]="opt.image" [style.display]="opt.label.toLowerCase().includes(search) ? '' : 'none'" (click)="onSelectValue(opt.value)" [class.checked]="opt.selected" [attr.data-value]="opt.value" [tabIndex]="openDropdown ? 0 : -1" role="option" [attr.aria-selected]="opt.selected">
              @if (type === 'MULTI_SELECT') {
                <div class="checkbox" [class.checked]="opt.selected"></div>
              }
              @if (opt.image) {
                <img [class.round]="roundImage" [src]="opt.image" alt="Image">
              }
              @if (!opt.html) {
                <span [class.multi-line]="multiLineOptionText" [class.wrap]="wrap">{{ opt.label }}</span>
              }
              @if (opt.html) {
                <span [outerHTML]="opt.html"></span>
              }
            </button>
          }
        }
        @if (oldSelectedValues.size && allOptionsKey) {
          <div class="section-text" [hasHTMLTags]="sectionIsHtml" [fiTranslation]="allOptionsKey" [replaceKeys]="replaceKeys"></div>
        }
      }
      @for (opt of displayedOptions; track opt; let i = $index) {
        @if (sectionTextKeys?.has(i)) {
          <div class="section-text" [hasHTMLTags]="sectionIsHtml" [fiTranslation]="sectionTextKeys.get(i)" [replaceKeys]="replaceKeys"></div>
        }
        @if (!showSelectedOnTop || (showSelectedOnTop && !oldSelectedValues.has(opt.value))) {
          <button type="button" [style]="opt.style" [class.has-image]="opt.image" [style.display]="opt.label.toLowerCase().includes(search) ? '' : 'none'" (click)="onSelectValue(opt.value)" [class.checked]="opt.selected" [attr.data-value]="opt.value" [tabIndex]="openDropdown ? 0 : -1" role="option" [attr.aria-selected]="opt.selected">
            @if (type === 'MULTI_SELECT') {
              <div class="checkbox" [class.checked]="opt.selected"></div>
            }
            @if (opt.image) {
              <img [class.round]="roundImage" [src]="opt.image" alt="Image">
            }
            @if (!opt.html) {
              <span [class.multi-line]="multiLineOptionText" [class.wrap]="wrap">{{ opt.label }}</span>
            }
            @if (opt.html) {
              <span [outerHTML]="opt.html"></span>
            }
          </button>
        }
      }
    </div>
  }
  @if (type === 'SELECT' || type === 'MULTI_SELECT') {
    <img [class.open]="openDropdown" [class.readonly]="readOnly" class="arrow" [class.reduced-height]="reducedHeight" alt="arrow" src="/assets/icons/arrow-up.svg">
  }
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

@if (controlName && form) {
  <div class="frame" [class.reduced-height]="reducedHeight" [class.open]="openDropdown" [class.readonly]="readOnly" #container [formGroup]="form" [class.error]="hasError">
    @if (additionalContentPosition === 'START') {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
    <input
      class="{{ controlName }}"
      [attr.enterkeyhint]="clearOnEnterOrSelect ? 'enter' : null"
      [class.reduced-height]="reducedHeight"
      [attr.maxlength]="maxLength ?? '500'"
      [class.is-dropdown]="type === 'SELECT' || type === 'MULTI_SELECT' || type === 'SUGGEST'"
      id="custom_input_{{ id }}"
      [name]="controlName"
      #input
      type="{{ inputType }}"
      (focus)="onFocus()"
      (input)="onInput()"
      (keydown.enter)="onEnter()"
      [fiTranslation]="placeholderKey"
      [isPLaceHolder]="true"
      [replaceKeys]="replaceKeys"
      [readonly]="readOnly || !enableSearch && (type === 'SELECT' || type === 'MULTI_SELECT') || type === 'DAY' || type === 'TIME'"
      [attr.required]="required ? '' : null"
      [attr.aria-invalid]="hasError ? 'true' : null"
      [attr.aria-describedby]="describedBy"
      [attr.role]="isDropdown ? 'combobox' : null"
      [attr.aria-haspopup]="isDropdown ? 'listbox' : null"
      [attr.aria-expanded]="isDropdown ? openDropdown : null"
      [attr.aria-controls]="isDropdown && openDropdown ? listboxId : null"
      [attr.aria-autocomplete]="isDropdown && enableSearch ? 'list' : null"
      [formControlName]="controlName"
      >
    @if (additionalContentPosition === 'END') {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
    <ng-container *ngTemplateOutlet="shared"></ng-container>
  </div>
}

@if (!controlName || !form) {
  <div class="frame" [class.reduced-height]="reducedHeight"  [class.open]="openDropdown" [class.readonly]="readOnly" #container [class.error]="hasError">
    @if (additionalContentPosition === 'START') {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
    <input
      [attr.enterkeyhint]="clearOnEnterOrSelect ? 'enter' : null"
      [class.reduced-height]="reducedHeight"
      [attr.maxlength]="maxLength ?? '500'"
      [class.is-dropdown]="type === 'SELECT' || type === 'MULTI_SELECT' || type === 'SUGGEST'"
      autocomplete="off"
      id="custom_input_{{ id }}"
      #input
      type="{{ inputType }}"
      (focus)="onFocus()"
      (input)="onInput()"
      (keydown.enter)="onEnter()"
      [fiTranslation]="placeholderKey"
      [isPLaceHolder]="true"
      [replaceKeys]="replaceKeys"
      [readonly]="readOnly || !enableSearch && (type === 'SELECT' || type === 'MULTI_SELECT') || type === 'DAY' || type === 'TIME'"
      [attr.required]="required ? '' : null"
      [attr.aria-invalid]="hasError ? 'true' : null"
      [attr.aria-describedby]="describedBy"
      [attr.role]="isDropdown ? 'combobox' : null"
      [attr.aria-haspopup]="isDropdown ? 'listbox' : null"
      [attr.aria-expanded]="isDropdown ? openDropdown : null"
      [attr.aria-controls]="isDropdown && openDropdown ? listboxId : null"
      [attr.aria-autocomplete]="isDropdown && enableSearch ? 'list' : null"
      >
    @if (additionalContentPosition === 'END') {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
    <ng-container *ngTemplateOutlet="shared"></ng-container>
    @if (type === 'TIME') {
      <div class="time-menu" [class.open]="showDateOrTimeDropdown">
        <div class="section-text" fiTranslation="REQUEST_DETAIL_APPOINTMENT_HOUR"></div>
        <div class="time-buttons">
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(6)" [class.selected]="selectedHour === 6">06</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(7)" [class.selected]="selectedHour === 7">07</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(8)" [class.selected]="selectedHour === 8">08</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(9)" [class.selected]="selectedHour === 9">09</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(10)" [class.selected]="selectedHour === 10">10</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(11)" [class.selected]="selectedHour === 11">11</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(12)" [class.selected]="selectedHour === 12">12</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(13)" [class.selected]="selectedHour === 13">13</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(14)" [class.selected]="selectedHour === 14">14</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(15)" [class.selected]="selectedHour === 15">15</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(16)" [class.selected]="selectedHour === 16">16</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(17)" [class.selected]="selectedHour === 17">17</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(18)" [class.selected]="selectedHour === 18">18</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(19)" [class.selected]="selectedHour === 19">19</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(20)" [class.selected]="selectedHour === 20">20</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(21)" [class.selected]="selectedHour === 21">21</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectHour(22)" [class.selected]="selectedHour === 22">22</button>
        </div>
        <div class="section-text" fiTranslation="REQUEST_DETAIL_APPOINTMENT_MINUTE"></div>
        <div class="time-buttons">
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectMinute(0)" [class.selected]="selectedMinute === 0">00</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectMinute(15)" [class.selected]="selectedMinute === 15">15</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectMinute(30)" [class.selected]="selectedMinute === 30">30</button>
          <button type="button" [tabIndex]="showDateOrTimeDropdown ? 0 : -1" (click)="selectMinute(45)" [class.selected]="selectedMinute === 45">45</button>
        </div>
      </div>
    }
    @if (type === 'DAY') {
      <div class="date-menu" [class.open]="showDateOrTimeDropdown">
        <fi-day-picker #dayPicker [unfocused]="!showDateOrTimeDropdown" [year]="selectedYear" [month]="selectedMonth" [day]="selectedDay" (onDateSelected)="displayDateAndTime($event, true)"></fi-day-picker>
      </div>
    }
    @if (!readOnly && type === 'DAY' && value?.trim()) {
      <button type="button" class="delete-btn" [class.reduced-height]="reducedHeight" (click)="displayDateAndTime(null, true)">
        <img alt="Close" src="/assets/icons/close-icon.svg">
        <span class="u-hidden-visually" fiTranslation="ALT_TEXT_INPUT_CLEAR"></span>
      </button>
    }
  </div>
}
@if ((errorKey || hintKey) && hasError) {
  <div class="error-message" [id]="'custom_input_' + id + '_error'" role="alert" [fiTranslation]="errorKey || hintKey" [params]="errorParams" [replaceKeys]="replaceKeys"></div>
}
@if (hintKey && !hasError) {
  <div class="hint" [id]="'custom_input_' + id + '_hint'" [fiTranslation]="hintKey" [replaceKeys]="replaceKeys"></div>
}


